export default {
  root: {
    class: ['flex', 'flex-col', 'overflow-x-auto'],
  },
}
